<template>
  <div>
    <Navbar />

    <section class="category-page">
      <Header
         formID="get-offer-birth"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="dogum-sigortasi-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <get-price-section :getPrice="getPrice" />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import getPriceSection from '@/component/categories/GetPriceSection'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import BirthInsuranceData from '@/data/category-page-data/BirthInsurance'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'

import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'Doğum (Hamilelik) Sigortası Fiyatları İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content:
          'Hamilelik sigortası hesaplama ve doğum sigortası fiyatları için online doğum sigortası teklifi alarak en uygun bekleme süresiz doğum sigortası seçin.'
      }
    ]
  },
  mixins: [filteredButtons],
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    getPriceSection,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.BIRTH,
      categoryInfo: BirthInsuranceData.categoryInfo,
      getPrice: BirthInsuranceData.getPrice,
      faqTitle: BirthInsuranceData.faqTitle,
      faqTitleDesc: BirthInsuranceData.faqTitleDesc,
      questions: BirthInsuranceData.questions,
      formData: {
        description: {
          upperText: 'Bekleme Süreli, Bekleme Süresiz',
          title: 'Doğum (Hamilelik) Sigortası Fiyatı Hesaplama',
          bottomText: 'Teklif İsteyin, En Doğru Planı Seçin'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'Alokasko’dan Doğum Sigortası Fiyatı Almak Çok Kolay!',
        description:
          'İster bekleme süreli, ister bekleme süresiz doğum sigortası;',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Giderleriniz Karşılansın',
            desc:
              'Anne ve bebeğin tüm sağlık giderleri doğum sigortası güvencesine alınabilir. En doğru zamanı kaçırmayın.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'İhtiyaca Uygun Plan',
            desc:
              'Tamamlayıcı sağlık sigortası doğum paketi - özel sağlık sigortası doğum paketi - hamileyken doğum sigortası paketleri size özel hazırlanır.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'En İyi Şirket Karşılaştırması',
            desc:
              'Hamileliğinizi güvence altına almak için doğum sigortası fiyatlarını en iyi şirketlerden karşılaştırın, poliçenizi kolayca oluşturun.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Taksit Seçenekleri',
            desc:
              'Hamilelik sigortasında ihtiyaca uygun satın alma. İster peşin, ister taksit imkânından yararlanın, doğum sigortanız güvenceniz olsun.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Doğum Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
